const AboutArticles = () => {
    return (
        <>
            <h2>Moji Članci</h2>
            <ul className="accordion-ul">
                <li className="accordion-li">
                    <input type="checkbox" defaultChecked={true} />
                    <i className="mg-top-arrow"></i>
                    <h2 className="accordion-title">Prihvatiti život</h2>
                    <p>
                        Na prošle dvije grupe dogodilo se nekoliko postava sa obiteljima u kojima je obitelji, naročito
                        majka i otac, bili energetski slomljeni, sudbina im je bila tako teška da su jedva imali snage
                        proslijediti život.
                    </p>
                    <p>
                        Djeca su i tim postavama postupila na dva različita načina: ili su se odmakla, pobjegla,
                        zatvorila jer im je bilo pre strašno i preteško li su se stopila i gotovo utopila u teretima
                        pokušavajući pomoći.
                    </p>
                    <p>
                        I jedan i drugi izbor nakon nekog vremena trebaju učiniti isto: prihvatiti svoj život onakav
                        kakav jest.
                    </p>
                    <p>
                        Oni koji su pobjegli i odbili sudjelovati moraju se vratiti, pogledati, osjetiti teret,
                        sagledati tešku sudbinu ali i osjetiti snagu u polomljenim dušama. S punim poštovanjem. U svima
                        koji su preživjeli da bi njihovi potomci djeca živjela.
                    </p>
                    <p>
                        Oni koji su pokušali pomoći, trebaju se odmaknuti, ostaviti teret onima kojima pripada, odustati
                        da svojom dječjom ljubavlju krpaju tuđe živote. Jer tako polako gase svoj. Sagledati tešku
                        sudbinu i osjetiti snagu u polomljenim dušama. S punim poštovanjem. U svima koji su preživjeli
                        da bi njihova djeca živjela.
                    </p>
                    <p>
                        I oba slučaja, osjetiti svoju snagu, koja im je proslijeđena od predaka i koja im je omogućila
                        da uspravno &#40; možda malo slomljeno &#41; pogledaju u ono što treba biti viđeno i poštivano.
                    </p>
                    <p>
                        Rečenica koja oslobađa zvuči zagonetno:{' '}
                        <b>Prihvaćam svoj život, dobila sam dovoljno, za ostao ću se pobrinuti sam/sama.</b>
                    </p>
                    <p>Tu se obično javlja otpor &#8722; kako dovoljno!! Trebao sam i zaslužila/o više!!</p>
                    <p>
                        Jesi, ali si dobio ono što je bilo moguće. I bilo je dovoljno jer došao si na svijet i živ/a si!
                    </p>
                    <p>Za početak.</p>
                    <p>
                        A za ostalo smo odgovorni pobrinuti se sami. Svojom odlukom da živimo, svojom otvorenošću prema
                        svijetu i ljudima, spremnošću da primijetimo i privlačimo pomoć svemira/boga/više sile..
                    </p>
                    <p>I uvijek dobijemo pomoć.</p>
                    <p>
                        Od medicinske sestra koja nam vlaži usta prije operacije, od tete koja nam ljubi ranu na nozi,
                        od učiteljice koja nam usadi strast prema knjizi, prema susjedi koja nam peče kolače, šefa koji
                        nas nauči prihvatiti autoritet, od ljubaznosti stranca koji primijeti da ste utučeni… I tako
                        svaki dan, cijeli život. Ako to primijetimo. A često nam promakne primijetiti i cijeniti. I tu
                        je naša odgovornost. Da vidimo da je ŽIVOT uz nas,
                    </p>
                    <p>
                        Naša je odgovornost da budemo otvoreni prema tim malim/velikim poklonima, da ih primijetimo i da
                        budemo zahvalni. Jer i to je dio životne energije koju smo primili i primamo.
                    </p>
                </li>
                <li className="accordion-li">
                    <input type="checkbox" defaultChecked={true} />
                    <i></i>
                    <h2 className="accordion-title">Biti Roditelj</h2>
                    <p>
                        Jednom prilikom, moja me kćer pitala što mi je kao roditelju bilo najkompliciranije. Odgovor ju
                        je možda iznenadio &#8722; najizazovnije su bile stalne promjene moje djece za koje sam i ja
                        morala stalno mijenjati moju ulogu roditelja i način na koji sam s njima komunicirala, na koji
                        sam bila dio njihovog života i oni mog.
                    </p>
                    <p>
                        Biti roditelj postaje se već u svojoj obitelji, prihvaćajući svoje roditelje, tete, bake, sve
                        žene u svojoj kulturi i podneblju. Prihvaćanjem uloge žene i uloge majčinstva. To je neki
                        maglovit osjećaj: „jednog dana biti ću majka“.
                    </p>
                    <p>
                        Sljedeći korak je u partnerstvu, odabrati oca svoje djece, osjećati se sigurno da svijete
                        gnijezdo.
                    </p>
                    <p>
                        Pravu spremnost testira trudnoća i rođenje i sva bura emocija, hormona, promjena životnih
                        uvjeta, novih mogućnosti i novih ograničenja. Osloboditi dio svojih kapaciteta i svjesno ih
                        pokloniti onom dijelu sebe koji odabire biti majka. Posložiti prioritete. I ma koliko to bilo
                        zbunjujuće, to je tek početak…
                    </p>
                    <p>
                        Na brzinu ću proći zanimljiv dio stalnih promjena: zauzimanje prostora od puzanja, hodanja,
                        trčanja, penjanja. Kad se naviknete na pogled bezuvjetne ljubavi, a onda vas „ostavi“ i krene u
                        avanturu stvaranja dječjih prijateljstava, zatim škola kada autoritet roditelja bude zaljuljan
                        autoritetom učiteljice, zatim autoritetom prijatelja, društva… i polako se vaše bespomoćno
                        „bundle of joy“ pretvara u odraslu osobu.
                    </p>
                    <p>I onda, opet, počinje novi teški dio.</p>
                    <p>
                        Od roditelja djece potrebno je transformirati se u roditelj odrasle osobe. Postaviti nove
                        granice.
                    </p>
                    <p>Prestati biti roditelj koji brine, postati roditelj koji ima povjerenje.</p>
                    <p>
                        Prestati biti roditelj koji daje savjete, postati roditelj koji strpljivo podupire stjecanje
                        iskustva.
                    </p>
                    <p>
                        Postati roditelj ponosan na način na koji je proslijedio život na najbolji mogući način i koji
                        je ponosan na rezultat &#8722; ponosan na osobe koje su „bivša“ djeca postala.
                    </p>
                    <p>
                        Prestati biti roditelj koji se brine o djeci i pokazati kako odrasla osoba brigom o sebi
                        pokazuje kako biti odgovorna odrasla osoba.
                    </p>
                    <p>
                        I onda naša djeca postaju zadovoljna jer smo mi zadovoljni, postaju slobodna jer ih mi
                        oslobađamo.
                    </p>
                    <p>
                        Prijelazni period od roditelja djeteta do roditelja odrasle osobe je jako zahtjevan i ponekad
                        zbunjujući. Jer ponekad djeca od vas traže savjet i onda se na savjet naljute. Ponekad traže
                        utjehu ali bez mudrovanja i petljanja u njihove odluke. Tako i mi i oni treniramo gdje su nam
                        nove podnošljive granice.
                    </p>
                    <p>
                        Roditelje taj period zbunjuje ali i boli. Boli pustiti svoju djecu. Boli jer ih njihovi
                        instinkti još uvijek gnjave da se o djeci brinu.
                    </p>
                    <p>
                        A treba ih pustiti da bi se mogli vratiti.
                        <b> Kao odrasli, odgovorni ljudi. A ako smo ih pustili, uvijek se vrate.</b>
                    </p>
                    <p>
                        Zbunjuje i jer, ponekad, to otvara prostor vrijeme i energiju da se vrate svom životu koji je u
                        međuvremenu promijenjen, a ponekad i opustošen. Da pogledaju u odgođeno, zanemareno, pod tepih
                        gurnuto… jer važna su bila djeca. A sad djece više nema. Pa se treba suočiti s problemima koji
                        se sada više ne mogu sakriti, prisjetiti se dana visoke energije, radosti, strasti, hobija…
                        Ponovo izgraditi svoj život.
                    </p>
                </li>
            </ul>
        </>
    );
};

export default AboutArticles;
